import Vue from 'vue'
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import { CREATE_WALLET, LOAD_AML_REPORTS, LOAD_WALLETS_LIST, RESET_WALLETS, SET_WALLET_DESCRIPTION, SET_WALLET_FROZEN } from "@/store/const/wallets";

export default {
  namespaced: true,
  state: {
    wallets: {
      list: [],
      pagination: {},
    },
    amlReports: {
      list: [],
      pagination: {},
    },
    statuses: {
      checking: 'На проверке',
      wait: 'Ожидание',
      in_progress: 'Выполняется',
      error: 'Ошибка',
      success: 'Выполнен',
    }
  },
  getters: {
    wallets: state => state.wallets,
    amlReports: state => state.amlReports,
    statuses: state => state.statuses,
  },
  actions: {
    [LOAD_WALLETS_LIST]: async ({ dispatch }, { params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_WALLETS_LIST,
        namespace: 'wallets',
        params,
      }, { root: true });
    },
    [LOAD_AML_REPORTS]: async ({ dispatch }, { address, params }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_AML_REPORTS,
        namespace: 'wallets',
        replace: { address },
        params,
      }, { root: true });
    },
    [CREATE_WALLET]: async ({ dispatch }, data = {}) => {
      return await dispatch(HTTP_POST, {
        method: CREATE_WALLET,
        namespace: 'wallets',
        no_commit: true,
        body: data,
      }, { root: true });
    },
    [SET_WALLET_FROZEN]: async ({ dispatch }, { address, frozen }) => {
      return await dispatch(HTTP_PUT, {
        method: SET_WALLET_FROZEN,
        namespace: 'wallets',
        no_commit: true,
        replace: { address },
        body: { frozen },
      }, { root: true });
    },
    [SET_WALLET_DESCRIPTION]: async ({ dispatch }, { address, description }) => {
      return await dispatch(HTTP_PUT, {
        method: SET_WALLET_DESCRIPTION,
        namespace: 'wallets',
        no_commit: true,
        replace: { address },
        body: { description },
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_WALLETS_LIST]: (state, { data }) => {
      Vue.set(state.wallets, 'list', data.list);
      Vue.set(state.wallets, 'pagination', data.pagination);
    },
    [LOAD_AML_REPORTS]: (state, { data }) => {
      Vue.set(state.amlReports, 'list', data.list);
      Vue.set(state.amlReports, 'pagination', data.pagination);
    },
    [RESET_WALLETS]: (state) => {
      Vue.set(state, 'wallets', { pagination: {}, list: []});
      Vue.set(state, 'amlReports', { pagination: {}, list: []});
    }
  },
};
